import React, { Component } from 'react';
import { FoodComponent } from '_components'
import { FoodType } from '_types'

type Props = {
	foods: FoodType[];
};

class FoodsPage extends Component<Props, any> {
  	render() {
		return (
			<React.Fragment>
				{this.props.foods.map((food) => (
				<FoodComponent key={food.id} food={food} />
				))}
			</React.Fragment>
		);
	}
}

export { FoodsPage };
